import { render, staticRenderFns } from "./ScheduleTabs.vue?vue&type=template&id=a3f5acfa&scoped=true"
import script from "./ScheduleTabs.vue?vue&type=script&lang=js"
export * from "./ScheduleTabs.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTabs.vue?vue&type=style&index=0&id=a3f5acfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f5acfa",
  null
  
)

export default component.exports